import get from "lodash/get"

const getFeatureByID = (data, id) => data.filter(item => item.id === id)

// Позволяет узнать о доступности статусов
export const selectStatusAvailable = state => {
  return get(getFeatureByID(state.features.data, `eventStatus`), `[0].enable`)
}

// Позволяет узнать о доступности уведомлений
export const selectNotificationsAvailable = state => {
  return get(getFeatureByID(state.features.data, `notifications`), `[0].enable`)
}

// Позволяет узнать о доступности тэгов в планах
export const selectPlanTagsAvailable = state => {
  return get(getFeatureByID(state.features.data, `planTags`), `[0].enable`)
}

// Позволяет получить кастомное поле события
export const selectEventCustomField = state => {
  return get(getFeatureByID(state.features.data, `eventCustomField`), `[0]`)
}
